// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__2T00m","section":"styles__section__3medr","sectionTitle":"styles__sectionTitle__EOwts","title":"styles__title__2aud7","row":"styles__row__3OC9I","capitalizedMessage":"styles__capitalizedMessage__2TFr_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/SectionSessionTimes/styles.css
// module id = 2345
// module chunks = 0